import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import MyContext from '../ContextApi/MyContext'

export default function AllTickets() {
    const { allMessages, ticketMessages } = useContext(MyContext)
    const [allTickets, setAllTickets] = useState([])
    const [ediitTicket, setEdiitTicket] = useState([])
    const [message, setMessage] = useState("")

    const convertToPST = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { timeZone: 'Asia/Karachi', timeZoneName: 'short' });
    };

    const tickets = async () => {
        const res = await fetch("https://capobiz-backend.vercel.app/api/auth/tickets", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
        const data = await res.json()
        setAllTickets(data)
    }

    useEffect(() => {
        tickets()
        ticketMessages()
    }, [])

    const deleteTicket = async (id) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Deleted!",
                    text: "Your ticket deleted successfully",
                    icon: "success",
                });
            }
            return result;
        });

        if (isConfirmed) {
            await fetch(`https://capobiz-backend.vercel.app/api/auth/delTicket/${id}`, {
                method: "DELETE"
            })
            tickets()
        }
    }

    const editTicket = async (id) => {
        const res = await fetch(`https://capobiz-backend.vercel.app/api/auth/getTicket/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
        const data = await res.json()
        setEdiitTicket(data)
    }

    const updateStatus = async (e) => {
        e.preventDefault()
        const { isConfirmed } = await Swal.fire({
            title: "Do you want to save the changes?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Save",
            denyButtonText: `Don't save`,
        });

        if (isConfirmed) {
            await fetch(`https://capobiz-backend.vercel.app/api/auth/updateTicket/${ediitTicket._id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ status: ediitTicket.status })
            })
            tickets()
            Swal.fire("Saved!", "", "success");
        } else {
            Swal.fire("Changes are not saved", "", "info");
        }
    }

    const sendMessage = async (e) => {
        e.preventDefault()
        const messageError = document.getElementById("mesageError")
        let hasError = false;

        if (!message) {
            messageError.innerText = "please enter message"
            hasError = true
        } else {
            messageError.innerText = ""
        }

        if (hasError) return;

        const userId = ediitTicket.userId._id
        const ticketId = ediitTicket._id
        const messageStatus = "Admin Message"

        const res = await fetch("https://capobiz-backend.vercel.app/api/auth/createMessage", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ message, userId, ticketId, messageStatus })
        })

        const data = await res.json()
        if (res.ok) {
            ticketMessages()
            setMessage("")
            const templateParams = {
                to_name: ediitTicket.userId.name,
                to_email: ediitTicket.userId.email,
                from_name: "Capobrain",
                message: data.message
            }
            sendEmail(templateParams)
        }
    }

    const sendEmail = (templateParams) => {
        // emailjs.send("service_wbh6u9i", "template_ia99i5d", templateParams, "Hr6iXXlEEhpzr5dMO")
    }

    return (
        <div>
            <table className="table table-bordered" style={{ backgroundColor: "white" }}>
                <thead>
                    <tr>
                        <th>Ticket Id</th>
                        <th>Severity</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {allTickets && allTickets.map((ticket) => (
                        <tr key={ticket._id}>
                            <td>{ticket.ticketId}</td>
                            <td>{ticket.severity}</td>
                            <td>{ticket.status}</td>
                            <td>
                                {/* Edit Button */}
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm me-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticEdit"
                                    onClick={() => editTicket(ticket._id)}
                                >
                                    Edit
                                </button>

                                {/* Delete Button */}
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm me-2"
                                    onClick={() => deleteTicket(ticket._id)}
                                >
                                    Delete
                                </button>

                                {/* View / Conversation Button */}
                                <button
                                    type="button"
                                    className="btn btn-outline-success btn-sm b"
                                    data-bs-toggle="modal"
                                    data-bs-target="#static"
                                    onClick={() => editTicket(ticket._id)}
                                >
                                    View
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Edit Status Modal */}
            <div
                className="modal fade"
                id="staticEdit"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Ticket Status</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <label className="form-label">Status</label>
                                <select
                                    name="status"
                                    id="status"
                                    value={ediitTicket.status || ''}
                                    onChange={(e) => setEdiitTicket({ ...ediitTicket, status: e.target.value })}
                                    className="form-select"
                                >
                                    <option value="Open">Open</option>
                                    <option value="Close">Close</option>
                                </select>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                            <button type="button" className="btn btn-primary" onClick={updateStatus} data-bs-dismiss="modal">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conversation Modal */}
            <div
                className="modal fade"
                id="static"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalToggleLabel">
                                Conversation - Ticket #{ediitTicket.ticketId}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body userMessageModal">
                            <p>Subject: <strong>{ediitTicket.subject}</strong></p>

                            <div className="card mb-3">
                                <div className="card-header bg-success text-white text-end">User</div>
                                <div className="card-body">
                                    <p>Hello Capobrain Team,</p>
                                    <p>Issue reported by: <strong>{ediitTicket.userId && ediitTicket.userId.name} ({ediitTicket.userId && ediitTicket.userId.email})</strong></p>
                                    <p>{ediitTicket.message}</p>
                                    <small className="text-muted">{convertToPST(ediitTicket.createAt)}</small>
                                </div>
                            </div>

                            <div className="my-3">
                                {allMessages && allMessages
                                    .filter(message => message.ticketId && message.ticketId.ticketId === ediitTicket.ticketId)
                                    .map((message) => (
                                        <div key={message._id} className="card mt-3">
                                            <div className={`card-header text-white text-end ${message.messageStatus === "Admin Message" ? "bg-success" : "bg-primary"}`}>
                                                {message.messageStatus === "Admin Message" ? "Owner" : "User"}
                                            </div>
                                            <div className="card-body">
                                                <p>{message.message}</p>
                                                <small className="text-muted">{convertToPST(message.createAt)}</small>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <form onSubmit={sendMessage}>
                                <textarea
                                    name="message"
                                    id="message"
                                    rows="8"
                                    className="form-control mt-3"
                                    placeholder="Type your message here..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                ></textarea>
                                <div id="mesageError" className="text-danger mt-1"></div>
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-primary" type="submit">
                                        Send Message
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}